// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1___6ce55f44ce340d8332f","cls2":"AutoCompleteResults-cls2___94b1cb5b338cc2d7372 AutoCompleteResults-cls1___6ce55f44ce340d8332f"};